import * as ActionTypes from '../action-types'

const vehicleReportRefuel_DefaultState = {
    reportByVID: {},
    logByVID: {},
    summaryByVID: {},
    allVIDs: []
}

export const vehicleReportRefuel = (state = vehicleReportRefuel_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_VEHICLE_REFUEL_REPORTS: {

            const report = action.report
            
            newState.reportByVID = {}

            report && report.length && report.map(r => {

                const {
                    refuels = [],
                    thefts = [],
                    vid 
                } = r

                newState.reportByVID[vid] = {
                    refuels,
                    thefts
                }

                if(!newState.allVIDs.includes(vid)) newState.allVIDs.push(vid)

                return null
            })

            // if(vid) {

            //     newState.reportByVID[vid] = {
            //         refuels,
            //         // thefts
            //     }

            //     // newState.logByVID[vid] = vLogs
            //     // newState.summaryByVID[vid] = summary

            //     if(!newState.allVIDs.includes(vid)) newState.allVIDs.push(vid)

            // }

            return newState
        }
        default: {
            return newState;
        }
    }
}